import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { IconSeeker } from "@ui-seeker/core"
import {Box} from "@mui/material";

import useFavFilterModal from "../../@hooks/useFavFilterModal"


export default function actionsColumn(dashboardKey) {
	return {
		name: "filterID",
		setBodyCellProps: () => ({ sx: { textAlign: 'center'} }),
		render: (value, row) => <IconCell filterID={value} row={row} dashboardKey={dashboardKey} />
	}
}

function IconCell({ filterID, row, dashboardKey }) {
	const { deleteFavGroupFilter, setFilterDefaultInDashboard } = useFavFilterModal()
	const iconWeight = useSignal('regular')

	return <Box display="flex" justifyContent="center">
		<IconSeeker
			icon='star'
			iconWeight={row?.defaultFilter ? 'solid' : 'regular'}
			onClick={() => {
				setFilterDefaultInDashboard(dashboardKey, row.filterID)
			}}
			tooltip={row?.defaultFilter ?
				'Delete Filter as default in this Dashboard'
				: 'Set Filter as default in this Dashboard'}
			sx={{ mr: 2, '&:hover': { cursor: 'pointer' } }}
		/>
		<IconSeeker
			icon='trash'
			iconWeight={iconWeight}
			onMouseOver={() => iconWeight.value = 'solid'}
			onMouseLeave={() => iconWeight.value = 'regular'}
			onClick={() => deleteFavGroupFilter(filterID)}
			tooltip="Delete Group of Filters"
			sx={{ '&:hover': { cursor: 'pointer' } }}
		/>
	</Box>
}